export class AsyncRequest {
    attempts = 0;
    startTime = 0;
    axiosInstance;
    options = {
        intervalMs: 2000,
        maxAttempts: 30,
        timeoutMs: 300000, // 5min
    };
    constructor(axiosInstance, options) {
        this.axiosInstance = axiosInstance;
        this.options = {
            ...this.options,
            ...options,
        };
    }
    hasExceededLimits() {
        if (this.attempts > this.options.maxAttempts) {
            return true;
        }
        if (Date.now() - this.startTime > this.options.timeoutMs) {
            return true;
        }
        return false;
    }
    getLimitError() {
        if (this.options.maxAttempts && this.attempts > this.options.maxAttempts) {
            return `Max attempts (${this.options.maxAttempts}) exceeded`;
        }
        if (Date.now() - this.startTime > this.options.timeoutMs) {
            return `Timeout (${this.options.timeoutMs}ms) exceeded`;
        }
        return "AsyncRequest limits exceeded";
    }
    isAsyncResponse(response) {
        return response.status === 202 && response.data?.request_id;
    }
    createRetryConfig(originalConfig, requestId) {
        return {
            ...originalConfig,
            params: {
                ...originalConfig.params,
                request_id: requestId,
            },
        };
    }
    async execute(config) {
        this.attempts = 0;
        this.startTime = Date.now();
        return new Promise((resolve, reject) => {
            const poll = async (currentConfiguration) => {
                if (config.signal?.aborted) {
                    reject(new Error("Request aborted"));
                    return;
                }
                this.attempts++;
                if (this.hasExceededLimits()) {
                    reject(new Error(this.getLimitError()));
                    return;
                }
                try {
                    const response = await this.axiosInstance.request(currentConfiguration);
                    if (this.isAsyncResponse(response)) {
                        const retryConfig = this.createRetryConfig(config, response.data.request_id);
                        setTimeout(() => {
                            poll(retryConfig);
                        }, this.options.intervalMs);
                    }
                    else {
                        resolve(response);
                    }
                }
                catch (error) {
                    reject(error);
                }
            };
            poll(config);
        });
    }
}
